import React from 'react';
import styled from 'styled-components';

const C4Style = styled.svg``;

export const C4 = ({ color }) => {
	return (
		<C4Style
			xmlns='http://www.w3.org/2000/svg'
			width='24.315'
			height='17.688'
			viewBox='0 0 24.315 17.688'
		>
			<path
				id='Mountains'
				d='M818.329,379.615l7.637,13.563a.85.85,0,0,1-.321,1.163.886.886,0,0,1-.426.11v0h-22.6a.857.857,0,0,1-.851-.857.844.844,0,0,1,.135-.461l8.968-15.931a.848.848,0,0,1,1.488,0l2.924,5.189,1.566-2.777a.849.849,0,0,1,1.161-.325.834.834,0,0,1,.322.325Zm3.409,9.537h0l-1.745-.94-.917.922,2.029,3.6h2.656l-2.023-3.585Zm-3.19-.945h0l.984-.975a.5.5,0,0,1,.614-.1l.656.352-3.214-5.706-1.324,2.357,2.284,4.075Zm.6,4.53h0L816.08,387.3l-.061-.027-1.859-1-2.187,2.179a.5.5,0,0,1-.716.006l-.007-.006-2.181-2.179-1.859,1-.061.027-3.062,5.441Zm-4-7.1h0q-1.769-3.136-3.53-6.273l-3.531,6.273.832-.45a.513.513,0,0,1,.608.089l2.09,2.09,2.073-2.079a.509.509,0,0,1,.62-.1l.838.45Z'
				transform='translate(-801.764 -376.766)'
				fill={color}
			/>
		</C4Style>
	);
};
